<!-- <template>
  <path
    fill="none"
    stroke="#333333"
    stroke-width="1.5"
    d="M1.5 1 L9.5 15 L17.5 1"
  />
</template> -->
<template>
  
    <!-- Main rounded rectangle -->
    <path
    fill="#bbbbbb"
    stroke="#333333"
    stroke-width="1"
    d="
      M 6 0
      a 2 2 0 0 0 -2 2
      v 14
      a 2 2 0 0 0 2 2
      h 6
      a 2 2 0 0 0 2 -2
      v -14
      a 2 2 0 0 0 -2 -2
      h -6
    "
    />

    

    <!-- Horizontal lines on the left -->
    <path
      fill="none"
      stroke="#333333"
      stroke-width="1.5"
      d="M-1 11 h 4 M-1 7 h 4"
    />

    <!-- Horizontal lines on the right -->
    <path
      fill="none"
      stroke="#333333"
      stroke-width="1.5"
      d="M15 11 h 4 M15 7 h 4"
    />
</template>
